import { DropdownArrow } from './DropdownArrow/DropdownArrow';
import { NavigationItem } from '../../../data/types';
import { createTag } from '../../../utils/tag-creators';
import * as s from './Navigation.scss';
import { userMenuData } from '../../../data/userMenu';
import { LanguagesIcon } from '../../LanguagePicker/LanguagesIcon';

export interface UserMenuProps {
  userName: string;
  userImage?: string;
  navigation: NavigationItem[];
  t(key: string): string;
  language: string;
}

interface UserMenuItemProps {
  item: NavigationItem;
  t(key: string): string;
  language: string;
}

const UserImage = (userImage?: string, alt?: string) => {
  return `
    <img class="${s.userImage}" src="${userImage}" alt="${alt}" />
  `;
};

const MenuItem = ({ item, t, language }: UserMenuItemProps) => {
  if (!item) {
    return '';
  }
  return `
    <li class="${s.userSubMenuItem}">
      ${createTag('a', t(item.text), {
        class: `${s.link}`,
        target: item.target,
        href: item.href,
        'data-bi-name': item.name,
        'data-bi-row': 'second',
        role: language === 'en' ? 'menuitem' : undefined,
      })}
    </li>
  `;
};

export const UserMenu = ({ navigation, t, userImage, userName, language }: UserMenuProps) => {
  const id = `user_profile-${Math.random()}`;
  return `
    <li
      data-hook="userMenu"
      class="${s.menuItem} ${s.userMenu}"
      data-expanded="false"
    >
      ${UserImage(userImage, t('profile_image'))}
       <div class="${s.linkWrapper} ${s.userName} ${s.desktopOnly}">
        <a
          id="${id}"
          class="${s.link} ${s.mainMenuButton}"
          title="${userName}"
          aria-label="User Profile"
          data-toggle="collapse"
          aria-expanded="false"
          data-bi-row="first"
          data-bi-name="account_name"
          data-hook="wix-header-account-name-button"
          role="button"
          href="#"
        >
          ${userName}
          ${DropdownArrow(s.arrow)}
        </a>
      </div>
      <span class="${s.userNameText} ${s.mobileOnly}" title="${userName}">
        ${userName}
      </span>
      <div class="${s.linkWrapper} ${s.signOut}">
        <a class="${s.link}" href="https://www.wix.com/signout" data-bi-row="second" data-bi-name="sign_out">
${t('menu_sign_out')}
        </a>
      </div>
      <div
        class="${s.userSubMenuContainer} items-${navigation.length}"
        role="region"
        aria-labelledby="${id}"
      >
        <ul
          class="${s.userSubMenu}"
          data-hook="wix-header-user-sub-menu"
          ${language === 'en' ? 'role="menu"' : ''}
        >
          ${navigation.map((item) => MenuItem({ item, t, language })).join('')}
          <li class="${s.userSubMenuItem}">
            <a
              class="${s.link} ${s.desktopOnly}"
              data-hook="language-picker"
              data-bi-name="languages"
              data-bi-row="second"
              role="button"
              href="#"
            >
              ${LanguagesIcon(s.iconLanguages)}
              <span class="${s.iconText}">${language.toUpperCase()}</span>
            </a>
          </li>
          ${MenuItem({ item: userMenuData.signOut, t, language })}
        </ul>
      </div>
    </li>
    <li class="${s.menuItemSeparator}" style="order: 0"></li>
  `;
};
